import { CustomerType } from '../../resources/base/models/enums';
import { getQuoteCoCustomers } from '../api/miles/miles-services';
import { assertDefinedVoid } from '../common/miscUtils';
import { CustomerState } from './features/customer.slice';

export const getInitialCustomerStateFromQuote = async (
  quote: QuoteSchema.Schemas.QuoteResponse
): Promise<CustomerState> => {
  const { customerData, financialProduct } = quote;
  const quoteId = quote.financialProduct?.offers?.[0]?.offerId;

  assertDefinedVoid(quoteId);
  assertDefinedVoid(customerData);

  const milesCustomerId = customerData?.externalIdentifiers?.find(({ type }) => {
    return type === 'MILES_CUSTOMER_ID';
  })?.id;

  assertDefinedVoid(milesCustomerId, 'milesCustomerId missing in restored quote');

  const partialCustomerDataCoCustomer = (await getQuoteCoCustomers(quoteId)).customerData;
  const milesCustomerIdCoCustomer =
    partialCustomerDataCoCustomer?.customerRelations?.[0]?.externalIdentifiers?.find(({ type }) => {
      return type === 'MILES_CUSTOMER_ID';
    })?.id ?? '';

  const customerType = customerData.customerType === 'INDIVIDUAL' ? CustomerType.INDIVIDUAL : CustomerType.LEGAL_ENTITY;
  const siren = customerData.companyData?.companyRegistrationNumber;
  const hasCoCustomer = !!milesCustomerIdCoCustomer;
  const milesCoCustomerRelationType = /* TODO: prefill once response quote contains proper fields */ '' as any;
  const legalEntity =
    customerData.companyData?.entityLegalForm; /* TODO: remove when customer service supports soletrader */
  const productName = financialProduct?.offers?.[0].productName;
  const posFrOccupation = undefined; /* TODO: remove when occupation is present in Miles customer data */
  const posFrOccupationCoCustomer = undefined; /* TODO: remove when occupation is present in Miles customer data */

  return {
    milesCustomerId,
    milesCustomerIdCoCustomer,
    customerType,
    stakeholderContacts: { SIGNATORY: undefined, DIRECTOR: undefined },
    availableSignatoryStakeholders: [],
    isSignatoryFormActive: false,
    shouldLinkDirectorStakeholder: false,
    shouldLinkSignatoryStakeholder: false,
    missingMilesData: {
      siren,
      hasCoCustomer,
      milesCoCustomerRelationType,
      legalEntity,
      productName,
      posFrOccupation,
      posFrOccupationCoCustomer,
    },
  };
};
